

/// <reference path="TipPool.ts" />

// Generated class EmployeePool_ManagedObject

class EmployeePool_ManagedObject extends TipPool
{
}
